// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bfm_a bhl_wj bhl_ss bhl_xl"};